/* eslint-disable graphql/template-strings */
import { gql } from '@apollo/client';

export const NotificationFields = gql`
  fragment NotificationFields on Notification {
    id
    userId
    title
    body
    imageUrl
    category
    action {
      action
      actionId
    }
    createdAt
    isRead
  }
`;
